import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import { registerUser } from '../../redux/actions';
import AOS from "aos";
import "aos/dist/aos.css";

const Register = ({error, loading, signUp}) => {

  const navigate = useNavigate();

  const [user_name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [user_hpnumber, setHpNumber] = useState('');
  const [recommend, setRecommend] = useState('');

  useEffect(() => {
    AOS.init();
    let message
    if (error !=='') {
      switch(error) {
      case "invalid recommend" : message = "추천인 코드가 맞지 않습니다."; break;
      case 'duplicate' : message = "이미 있는 계정입니다."; break;
      default : message = "Register Error"; break;
      }
      toast.error(message);
    }

  }, [error, loading]);

  const onSubmit = (event) => {
    event.preventDefault();
    
    if (user_name.length === 0 ||recommend.length === 0 ||email.length === 0 ||password.length === 0)
    {
      toast.error('비어 있는 필드가 있습니다.');
      return;
    }
    if (validateEmail(email) !== '')
    {
      toast.error('email이 형식에 맞지 않습니다.');
      return;
    }

    if (!loading) {
      const user = { email : email, password : password, recommend: recommend, user_name : user_name, user_hpnumber : user_hpnumber }
      signUp(user, navigate);
    }

  };

  const validateEmail = (value) => {
    let error = '';
    if (!value) {
      error = 'Please enter your email address';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = 'Invalid email address';
    }
    return error;
  };

  const linkTo = (link) => {
    navigate('/' + link);
  }
  return  (
    <div className="container">
      <div className="toptitle" >
        <span onClick={() =>linkTo('welcome')}>
          <i className="fa-solid fa-arrow-left"></i>
        </span>
        <span>SignUp</span>
      </div>
      <div id="register_welcome" className="welcome" data-aos="fade-right">
        Welcome
      </div>

      <div className="containerForm" data-aos="fade-down" data-aos-duration="1400" data-aos-anchor-placement="center-bottom" >

      <label className="usertitle">사용자 이름</label>
        <input 
          className="userinput"
          placeholder="이름"
          value={user_name} 
          onChange={e => setName(e.target.value)}
        />

        <label className="usertitle">아이디(이메일)</label>
        <input 
          className="userinput"
          placeholder="이메일"
          value={email} 
          onChange={e => setEmail(e.target.value)}
        />

        <label className="usertitle"> 패스워드</label>
        <input
          className="userinput"
          placeholder="패스워드"
          value={password}
          onChange={e => setPassword(e.target.value)}
          type="password"
        />

      <label className="usertitle">핸드폰 번호</label>
        <input
          className="userinput"
          placeholder="핸드폰 번호"
          value={user_hpnumber}
          onChange={e => setHpNumber(e.target.value)}
          type="text"
        />
      
      <label className="usertitle">스마트 코드</label>
        <input
          className="userinput"
          placeholder="스마트 코드"
          value={recommend}
          onChange={e => setRecommend(e.target.value)}
          type="text"
        />

        <div className='submitButton' >
          <button onClick={onSubmit} className="button">
            가입
          </button>
        </div>

      </div>
    </div>
  );
};

const mapStateToProps = ({ authUser }) => {
  const { loading, error } = authUser;
  return { loading, error };
};

export default connect(mapStateToProps, { 
  signUp : registerUser
})(Register);


